import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { StepCard, type StepCardAction } from "../../../../../molecules/StepCard";
import { useBookingSelector } from "../../../../BookingForm/hooks/useBookingSelector";
import type { CommercialRenewalStepProps } from "../types";
import { useSubmitRenewalForApproval } from "./useSubmitRenewalForApproval";
import { useWhatsChangingComparison } from "./useWhatsChangingComparison";
import { WhatsChangingSection } from "./WhatsChangingSection";

export const PreviewStep = (props: CommercialRenewalStepProps) => {
  const { title, onDiscard, onBack, isSentForApproval } = props;
  const navigate = useNavigate();
  const { leaseId = "" } = useParams();
  const bookingDetails = useBookingSelector();
  const { rows } = useWhatsChangingComparison(bookingDetails);
  const { submitForApproval, saveDraft } = useSubmitRenewalForApproval();
  const requiresApproval = bookingDetails?.renewalApproval === "enable";

  const goToBookingDetail = () => {
    if (leaseId) navigate(`/viewbookingform/${leaseId}`, { state: { renewal: true } });
  };

  const handlePrimaryAction = () => {
    if (isSentForApproval) {
      goToBookingDetail();
      return;
    }
    if (requiresApproval) {
      submitForApproval();
      return;
    }
    onDiscard();
  };

  const actions: StepCardAction[] = [
    { key: "discard", label: "Discard", variant: "secondary", onClick: onDiscard },
    ...(isSentForApproval
      ? []
      : [{ key: "draft", label: "Save Draft", variant: "subtle" as const, onClick: saveDraft }]),
    {
      key: "submit",
      label: requiresApproval ? "Send for Approval" : "Submit",
      variant: "primary",
      onClick: handlePrimaryAction,
    },
  ];

  return (
    <StepCard title={title} onBack={onBack} actions={actions}>
      <WhatsChangingSection rows={rows} />
    </StepCard>
  );
};
